var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.99,
    height: 123.99,
    viewBox: "0 0 123.99 123.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_140",
    "data-name": "Gruppe 140",
    transform: "translate(-385 -2305)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 12.916,
    cy: 12.916,
    r: 12.916,
    transform: "translate(392.749 2346.33)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_136",
    "data-name": "Pfad 136",
    d: "M423.747,2319H387.583a2.584,2.584,0,0,0-2.583,2.583c0,12.342.827,23.7,10.333,27.453v19.043a2.584,2.584,0,0,0,2.583,2.583h15.5a2.584,2.584,0,0,0,2.583-2.583v-19.043c9.506-3.751,10.333-15.111,10.333-27.453A2.584,2.584,0,0,0,423.747,2319Z",
    transform: "translate(0 58.328)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 12.916,
    cy: 12.916,
    r: 12.916,
    transform: "translate(475.409 2346.33)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_137",
    "data-name": "Pfad 137",
    d: "M439.747,2319H403.583a2.584,2.584,0,0,0-2.583,2.583c0,12.342.827,23.7,10.332,27.453v19.043a2.584,2.584,0,0,0,2.583,2.583h15.5a2.584,2.584,0,0,0,2.583-2.583v-19.043c9.506-3.751,10.332-15.111,10.332-27.453A2.584,2.584,0,0,0,439.747,2319Z",
    transform: "translate(66.66 58.328)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 12.916,
    cy: 12.916,
    r: 12.916,
    transform: "translate(434.079 2305)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_138",
    "data-name": "Pfad 138",
    d: "M431.747,2311H395.583a2.585,2.585,0,0,0-2.583,2.583c0,12.341.827,23.7,10.332,27.453v19.043a2.584,2.584,0,0,0,2.583,2.583h15.5a2.585,2.585,0,0,0,2.583-2.583v-19.043c9.506-3.751,10.332-15.112,10.332-27.453A2.585,2.585,0,0,0,431.747,2311Z",
    transform: "translate(33.33 24.998)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.7cbaf858.svg";
export { ForwardRef as ReactComponent };